import { sendEvent } from "~/app/analytics/ga/ga";

export function trackSubmit(success: boolean) {
  sendEvent({
    event: "Contact_Form_Interaction",
    action: "Contact Form Submitted",
    raw_action: "Click",
    status: success ? "Successful" : "Unsuccessful",
  });
}
